import TextField from "@mui/material/TextField";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { updateCategory } from "../../feature/category/categorySlice";
import { Alert, Snackbar } from "@mui/material";

const UpdateCategoryForm = (props) => {
  const [categoryName, setCategoryName] = useState("");

  const [open, setOpen] = useState(false);

  const { isLoading, isSuccess, isError, message } = useSelector(
    (state) => state.categories
  );

  useEffect(() => {
    setCategoryName(props.category_name);
  }, []);

  const dispatch = useDispatch();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const categoryDetails = { id: props.id, category_name: categoryName };
    dispatch(updateCategory(categoryDetails));
    if (isSuccess && message !== "") {
      console.log("success response", message);
      setCategoryName("");
    } else {
      console.log("error response", message);
    }
  };

  if (isLoading) return <h2>Loading...</h2>;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Stack direction='column' spacing={2}>
          <TextField
            fullWidth
            label='Category Name'
            id='category_name'
            value={categoryName}
            onChange={(e) => {
              setCategoryName(e.target.value);
            }}
            required
          />
          <Stack direction='row' spacing={2}>
            <Button
              disabled={!categoryName}
              variant='contained'
              type='submit'
              onClick={handleClick}
            >
              Update
            </Button>
            <Button variant='contained' color='error'>
              CANCEL
            </Button>
          </Stack>
        </Stack>
      </form>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='success' sx={{ width: "100%" }}>
          Your Category is Updated!
        </Alert>
      </Snackbar>
    </>
  );
};

export default UpdateCategoryForm;
